const ContactPreferenceOptions = {
  telephone: "Telephone",
  email: "Email",
  letter: "Letter",
  letterAndEmail: "Letter and Email",
  largePrintLetter: "Large print letter",
};

export default ContactPreferenceOptions;
